//#region Imports
import { Box, Tooltip, IconButton } from "@mui/material";

import { useColorScheme } from "@mui/material";

import { useDispatch } from "react-redux";
import { toggleThemeModal } from "../../store/slicers/General Slicer";

import { usePostLogoutMutation } from "../../store/api/auth api";

// Icons
import ThemeToggleIcon from "../../additional/components/animated elements/Theme Toggle Icon";
import BugReportIcon from "@mui/icons-material/BugReport";
import DeveloperBoardIcon from "@mui/icons-material/DeveloperBoard";
import LogoutIcon from "@mui/icons-material/Logout";
import DisplaySettingsIcon from "@mui/icons-material/DisplaySettings";
//#endregion

/**
 * Control panel component with buttons for switching the theme, reporting an error, and requesting an update.
 * @param {Object} props Props of the element;
 * @param {Boolean} [props.isMobile=false] Whenether mobile or desktop render needed. By default false;
 * @returns {JSX.Element} An element that contains control buttons.
 */
const ControlButtons = ({ isMobile = false }) => {
  const { mode, setMode } = useColorScheme();
  const dispatch = useDispatch();
  const [postLogout] = usePostLogoutMutation();

  const controlButtons = [
    {
      icon: <ThemeToggleIcon isDarkMode={mode === "dark"} />,
      name: "Toggle light mode",
      onClick: () => setMode(mode !== "light" ? "light" : "dark"),
    },
    {
      icon: <DisplaySettingsIcon />,
      name: "Change theme",
      onClick: () => dispatch(toggleThemeModal(true)),
    },
    {
      icon: <BugReportIcon />,
      name: "Report bot's bug",
      onClick: () => {
        window.open("https://inflow.infuse.com/forms/177/", "_blank").focus();
      },
    },
    {
      icon: <DeveloperBoardIcon />,
      name: "Request update / new bot development",
      onClick: () => {
        window.open("https://inflow.infuse.com/forms/168/", "_blank").focus();
      },
    },
    {
      icon: <LogoutIcon />,
      name: "Logout",
      onClick: async () => {
        await postLogout();
        window.location.reload();
      },
    },
  ];

  return (
    <Box sx={isMobile || { flex: "1", textAlign: "end" }}>
      {controlButtons.map((buttons) => (
        <Tooltip
          key={buttons.name}
          title={buttons.name}
          placement="bottom"
          arrow>
          <IconButton
            onClick={buttons.onClick}
            size={isMobile ? "small" : "medium"}
            sx={{ ml: 1 }}
            color="inherit">
            {buttons.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default ControlButtons;
